<template>
    <teleport to="body">
        <transition name="slide-up">
            <div
                v-if="visible"
                class="agent-mode-overlay">
                <slot name="body" />
            </div>
        </transition>
    </teleport>
</template>

<script>
export default {
    name: 'ArtifactModal',
    props: {
        visible: {
            type: Boolean,
            required: true,
        },
    },
};
</script>

<style scoped lang="less">
.agent-mode-overlay {
    position: fixed;
    inset: 0;
    background: var(--palette-gray-0);
    z-index: 1000;
    overflow: auto;
    box-shadow: 0px 13px 28px 0px var(--semantic-drop-shadow-base);
    border-radius: 16px;
    inset: var(--top-nav-height, 52px) 16px 16px 16px;
    border: 1px solid var(--palette-gray-40);
}

.slide-up-enter-active,
.slide-up-leave-active {
    transition: transform 0.3s ease-out, opacity 0.3s ease-out;
}

.slide-up-enter-from {
    transform: translateY(100%);
    opacity: 0;
}

.slide-up-leave-to {
    transform: translateY(100%);
    opacity: 0;
}

</style>